import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { InicioComponent } from './inicio/inicio.component';
import { AuthGuard } from './guards/auth.guard';
import { ProductosComponent } from './productos/productos.component';
import { VentasComponent } from './ventas/ventas.component';
import { SuppliersComponent } from './suppliers/suppliers.component';
import { ReportGeneratorComponent } from './report-generator/report-generator.component';
import { SupplierReportComponent } from './report-generator/supplier-report/supplier-report.component';
import { InicioAdaptativoComponent } from './inicio/inicio-adaptativo/inicio-adaptativo.component';
import { CortesProveedorComponent } from './cortes-proveedor/cortes-proveedor.component';
import { CortesListaComponent } from './cortes-lista/cortes-lista.component';
import { ProduccionComponent } from './produccion/produccion.component';
import { CorteCajaComponent } from './corte-caja/corte-caja.component';
import { HistorialInventarioComponent } from './historial-inventario/historial-inventario.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'main',
    canActivate: [AuthGuard],
    children: [
      { path: 'inicio', component: InicioAdaptativoComponent },
      // Keep other routes that you already have
      { path: 'productos', component: ProductosComponent }, // Replace with actual component when available
      { path: 'ventas', component: VentasComponent }, // Replace with actual component when available
      { path: 'proveedores', component: SuppliersComponent }, // Replace with actual component when available
      { path: 'reportes', component: ReportGeneratorComponent }, // Replace with actual component when available
      { path: 'reportes-proveedor', component: SupplierReportComponent },
      { path: 'cortes', component: CortesListaComponent },
      { path: 'cortes-proveedor', component: CortesProveedorComponent },
      { path: 'produccion', component: ProduccionComponent },
      { path: 'corte-caja', component: CorteCajaComponent },
      { path: 'historial-inventario', component: HistorialInventarioComponent },
      { path: 'configuracion', component: InicioAdaptativoComponent }, // Replace with actual component when available
      { path: '', redirectTo: 'inicio', pathMatch: 'full' }
    ]
  },
  // Redirect empty path to main/inicio if authenticated, otherwise to login
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // Catch all route - redirect to login
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
